import React, { useMemo, useEffect, useState } from 'react';
import axios from 'axios';

const CollegeVideo = ({ college_id }) => {
    const token = useMemo(() => localStorage.getItem('token') || '', []);
    const [videoData, setVideoData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://api.admissionsbazaar.com/college/college-video/${college_id}/`);
                const data = response.data;
                setVideoData(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [college_id, token]);

    if (loading) {
        return <p>Loading...</p>;
    }

    console.log("video",videoData)
    return (
        <div className='gallery'>
            <div className='long_border'>
                <h3 className='text-center'>Video</h3>
            </div>
            <div className='h_of_card'>
                {videoData && videoData.length > 0 ? (
                    <div className='row'>
                        {videoData.map((data) => (
                            <div className='col-lg-12' key={data.id}>
                                <div className='picc mt-2'>
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/IDjccBHai1A?si=JgCiOR7G_7tHohLN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                   
                                    <iframe
                                        src={`${data.youtube_video_id}`}
                                        title={data.title}
                                        width="560"
                                        height="315"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No video available</p>
                )}
            </div>
        </div>
    );
};

export default CollegeVideo;
